import { Injectable, TemplateRef, WritableSignal, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ScreenSizes } from '../classes/screen-sizes.class';
import { ContextMenuOptions } from '../components/context-menu-global/context-menu-global.component';
import { enableBodyScroll } from '../lib/toggle-body-scroll';
import { AppExtraLoadingService } from './app-extra-loading.service';
import { SwipeService } from './swipe.service';
import { TooltipService } from './tooltip.service';

export interface ContextMenuComponent {
  position: string;
  verticalPosition: string;
  options: ContextMenuOptions;
  contextHoverIdentifiers: string[];
  component: { close: () => void; _isOpen: WritableSignal<boolean>; isOpen: WritableSignal<boolean> };
  clientEl: HTMLElement;
  template: TemplateRef<unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class ContextMenuService {
  private tooltipService = inject(TooltipService);
  private appExtraLoadingService = inject(AppExtraLoadingService);
  private swipeService = inject(SwipeService);
  public readonly onContextOpen = new BehaviorSubject<ContextMenuComponent>(undefined);
  public readonly onContextContentHover = new BehaviorSubject<boolean>(undefined);
  public readonly openContextMenu = new Subject<string>();

  constructor() {
    this.swipeService.start();
    this.swipeService.onSwipe.subscribe(direction => {
      if (direction === 'down') {
        this.closeContext();
      }
    });
  }

  // Should only be used from the ContextMenuComponent
  public async showContext(component: ContextMenuComponent): Promise<boolean> {
    this.appExtraLoadingService.load$.next('contextMenus');
    this.tooltipService.hide();
    this.onContextOpen.next(component);
    return true;
  }
  // Should only be used from the ContextMenuComponent
  public hideContext() {
    this.onContextOpen.next(undefined);
    if (ScreenSizes.screenSize() === 'mobile') enableBodyScroll();
  }

  public closeContext() {
    this.onContextOpen.value?.component.close();
  }
}
